const {Core, Events} = Global;
const CN_ACTIVE = '!active';
const CN_LOADING = '!loading';

customElements.define('sticky-add-to-cart', class extends Core {

    elements = {
        $: ['wrapper']
    }

    render() {
        this.sub(Events.VARIANT_CHANGE, this._toggleLoading(true));
        this.sub(Events.VARIANT_UPDATE, () => {
            this._toggleLoading(false)();
            this._scheduleVisibility();
        });

        this._handleTrigger();
    }

    _handleTrigger() {
        this.provider = this.closest('product-variant-provider');
        this._onScroll = () => this._scheduleVisibility();
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll);
        this.resizeObserver = new ResizeObserver(this._onScroll);
        // Both purchase markup and the sticky wrapper can be replaced on a
        // variant update. Re-find them instead of observing a detached button.
        this.mutationObserver = new MutationObserver(this._onScroll);
        if (this.provider) this.mutationObserver.observe(this.provider, { childList: true, subtree: true });
        this.dialogObserver = new MutationObserver(this._onScroll);
        this.dialogObserver.observe(document.body, { attributes: true, attributeFilter: ['open'], subtree: true });
        this._scheduleVisibility();
    }

    _scheduleVisibility() {
        if (this.visibilityTimer) return;
        this.visibilityTimer = setTimeout(() => {
            this.visibilityTimer = null;
            if (this.isConnected) this._updateVisibility();
        }, 16);
    }

    _updateVisibility() {
        const wrapper = this.querySelector('[data-element="wrapper"]');
        if (!wrapper) return;
        if (wrapper !== this.wrapper) {
            if (this.wrapper) this.resizeObserver.unobserve(this.wrapper);
            this.wrapper = wrapper;
            this.resizeObserver.observe(wrapper);
            // The top layer avoids transformed/low-z-index product ancestors
            // and the footer's z-index:999 without moving form controls in DOM.
            if (typeof wrapper.showPopover === 'function') wrapper.setAttribute('popover', 'manual');
        }
        const modalOpen = !!document.querySelector('dialog[open]');
        if (typeof wrapper.showPopover === 'function') {
            const layerOpen = wrapper.matches(':popover-open');
            if (modalOpen && layerOpen) wrapper.hidePopover();
            if (!modalOpen && !layerOpen) wrapper.showPopover();
        }
        const button = this.provider?.querySelector('product-form [data-main-purchase-button]');
        if (button !== this.button) {
            if (this.button) this.resizeObserver.unobserve(this.button);
            this.button = button;
            if (button) this.resizeObserver.observe(button);
        }
        const distance = Math.max(0, Number(this.dataset.triggerDistance) || 0);
        const visible = !modalOpen && !!button && button.getClientRects().length > 0 && button.getBoundingClientRect().bottom <= -distance;
        this.active = visible;
        wrapper.inert = !visible;
        if (!visible) this.querySelector('drop-down')?.close();
        this._setBodyOffset();
    }

    _setBodyOffset() {
        const bottom = this.classList.contains('@position:bottom') && this.classList.contains(CN_ACTIVE);
        document.body.style.setProperty('--bottom-offset', `${bottom ? this.wrapper?.offsetHeight || 0 : 0}px`);
    }

    destroy() {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
        clearTimeout(this.visibilityTimer);
        this.visibilityTimer = null;
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        this.dialogObserver?.disconnect();
        this.wrapper = null;
        this.button = null;
        document.body.style.removeProperty('--bottom-offset');
    }

    _toggleLoading(state) {
        return () => {
            if (state) {
                // A local variant update can finish inside the change event.
                // Read the provider after dispatch, rather than leaving the
                // sticky overlay on because of subscription ordering.
                queueMicrotask(() => {
                    if (this.isConnected) this.classList.toggle(CN_LOADING,
                        !!this.closest('product-variant-provider')?.hasAttribute('aria-busy'));
                });
                return;
            }
            this.classList.toggle(CN_LOADING, state);
        }
    }

    set active(state) {
        this.classList.toggle(CN_ACTIVE, state);
    }
})
